import { connect } from 'react-redux';
import { joinWaitlist, checkWaitlist, requestHotelSearch, requestHotelClaim, addHotel,addHotelPhoto,requestBrandOptions,addHotelContact,removeHotelContact,editHotel,editHotelFeatures,editLandmark,postHotelAddLandmark,removeLandmark } from '../modules/hotels';
//import { requestBrandOptions } from '../../tours/modules/tour';
import AddNewHotel from '../components/AddNewHotel';

const mapDispatchToProps = {
  requestHotelSearch,
  requestHotelClaim,
  joinWaitlist,
  checkWaitlist,
  addHotel,
  addHotelPhoto,
  requestBrandOptions,
  addHotelContact,
  removeHotelContact,
  editHotel,
  editHotelFeatures,
  editLandmark,
  postHotelAddLandmark,
  removeLandmark
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.search.isFetching,
  needFetch: state.hotels.search.needFetch,
  hasError: state.hotels.search.hasError,
  hotel: state.hotels, 
  onWaitlist: state.hotels.waitlist.onWaitlist,
  waitlistisFetching: state.hotels.waitlist.needFetch || state.hotels.waitlist.isFetching,
  perms: state.auth.perms,
  id: ownProps.params.id,
  brands: state.hotels.brands,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewHotel);



// WEBPACK FOOTER //
// src/routes/hotels/containers/AddNewHotelContainer.js